/**
 * @generated SignedSource<<3dc0566cfaf9da571a01f1c06eafb96f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type profileSecurity_viewer$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsProfileSubNav_viewer">;
  readonly " $fragmentType": "profileSecurity_viewer";
};
export type profileSecurity_viewer$key = {
  readonly " $data"?: profileSecurity_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"profileSecurity_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "profileSecurity_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SettingsProfileSubNav_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1363c06b358bafb6a704bb6771734df4";

export default node;
